import { render, staticRenderFns } from "./ComplaintReasonList.vue?vue&type=template&id=0657ff51&"
import script from "./ComplaintReasonList.vue?vue&type=script&lang=js&"
export * from "./ComplaintReasonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports